export const translatePT = {
  pt: {
    validations: {
      required: "Esse campo é obrigatório",
      min: "Número mínimo de caracteres é {min}",
      max: "Número máximo de caracteres é {max}",
      time: "Digite um tempo válido",
      email: "Digite um email válido",
      sameAs: "As senhas devem corresponder",
      validName: "Digite o nome completo",
      validCPF: "Digite um CPF válido",
      validCNPJ: "Digite um CNPJ válido",
      validTime: "Digite um horário válido",
      validStartTime: "O horário inicial deve ser maior que o atual",
      validEndTime: "O horário final deve ser maior que o inicial",
      validDate: "",
      validTimeInterval: "A duração máxima é de 4 horas",
      validImage: "Coloque uma imagem válida",
      validResolution: "Coloque uma imagem em uma resolução até (250x70)",
      validUrl: "Digite uma URL válida",
    },
    labels: {
      add: "Adicionar {pt}",
      edit: "Editar {pt}",
      new: "Novo {pt}",
      back: "Voltar {pt}",
      cancel: "Cancelar {pt}",
      save: "Salvar {pt}",
      continue: "Continuar {pt}",
      select: "Selecionar {pt}",
      apply: "Aplicar",
      delete: "Apagar {pt}",
      finalize: "Finalizar {pt}",
      proceed: "Prosseguir",
      enter: "Entrar",
      generic: "{pt}",
      yes: "Sim",
      no: "Não",
      confirm: "Confirmar",
    },
    users: {
      form: {
        add: "Adicionar usuário",
        edit: "Editar usuário",
        name: "Nome completo",
        org: "Organização",
        birthdate: "Data de nascimento",
        type: "Tipo de usuário",
        roles: {
          adm: "Administrador",
          teacher: "Professor",
          std: "Aluno",
        },
        userTypes: {
          active: "Ativado",
          inactive: "Inativo",
          blocked: "Bloqueado",
        },
      },
    },
    course: {
      title: "Cursos",
      create: "Criar novo curso",
      search: "Pesquisar cursos",
      tabs: {
        all: "Todos os cursos",
        published: "Publicado",
        notPublished: "Não publicado",
        approved: "Aprovado",
        repproved: "Reprovado",
        waiting: "Aguardando aprovação",
        notListed: "Não-listado",
      },
      form: {
        add: "Criar novo curso",
        edit: "Editar curso",
        subtitle: "Informações gerais",
        name: "Nome do curso",
        thumb: "Adicionar imagem do curso",
        categories: "Categorias",
        description: "Resumo",
        duration: "Duração",
        hasCertificate: "Possui certificado no curso",
        certificateType: "Tipo de certificado",
        certificatePlaceholder: "Selecione o tipo de certificado",
        materialInteractive: "Material interativo",
        materialInteractiveDescription: "Selecione o material interativo",
        types: {
          adaptive:
            "O curso adaptativo é baseado na estrutura de grafos, você deve criar planos de aulas obrigatórios e também planos complementares. A estrutura do curso é formado por capítulos, objetivos de aprendizagem e objetos.",
          traditional:
            "O curso tradicional é baseado na estrutura linear. A estrutura do curso é formada por capítulos e objetos.",
          listed:
            "O curso aparecerá para o aluno, caso ele tenha sido matriculado.",
          nonListed:
            "O curso não será exibido para o aluno, você terá que aprovar novamente o curso, caso queira alterar essa opção.",
          interactive:
            "O curso interativo utiliza conteúdos H5P, permitindo experiências de aprendizagem dinâmicas e atividades interativas diretamente na plataforma.",
        },
      },
      empty: {
        courses:
          "Você ainda não adicionou nenhum curso, clique em “Criar um curso”.",
        chapters:
          "Os capítulos e conteúdos cadastrados ficarão listados neste espaço. Clique em “Adicionar capítulo” para começar",
        objectives: "",
        objects: "",
      },
    },
    studentCourse: {
      empty: {
        materialBeingWatch: {
          title: "Nenhum material selecionado",
          description:
            "Clique em um dos capítulos liberados no menu à esquerda para visualizar o conteúdo.",
        },
      },
      errors: {
        video: `
        <p>Recarregue a página.</p>
        <h4>Oops! Não foi possível carregar o vídeo. Verifique sua conexão.</h4>`,
        pdf: {
          title: "Recarregue a página",
          description:
            "Oops! Não foi possível carregar o PDF. Verifique sua conexão.",
        },
      },
    },
    chapters: {
      title: "Conteúdo do curso",
      add: "Adicionar capítulo",
      edit: "Editar capítulo",
      form: {
        name: "Nome do capítulo",
        predecessor: "Informar capítulo antecessor",
        description: "Descrição",
        date: "Data de início (opcional)",
      },
    },
    objectives: {
      titles: {
        info: "Informações gerais",
        materials: "Objetos",
        lessonPlans: "Planos de aula",
        quiz: "Quiz",
        objectives: "Objetivos",
      },
      inputs: {
        name: "Nome do objetivo",
        objective: "Objetivo",
        description: "Descrição",
        type: "Tipo do material",
        title: "Título",
        predecessor: "Objetivo de aprendizado antecessor",
      },
    },
    objects: {
      add: "Adicionar objeto",
      edit: "Editar objeto",
      plans: "Planos",
      withoutplan: "Sem plano",
      essential: "Essencial",
      complementary: "Complementar",
      type: {
        intro: "Introdução",
        motivation: "Motivação",
        dev: "Desenvolvimento",
        closure: "Fechamento",
      },
      inputs: {
        classification: "Classificação",
        name: "Nome do objeto",
        predecessor: "Objeto de aprendizagem antecessor",
        related: "Conteúdo relacionado",
        file: "Fazer upload ",
        select: "Selecione a classificação",
        time: "Tempo de visualização do objeto",
      },
      empty: {
        title: "Nenhum objeto adicionado",
        description:
          "Os objetos ficarão listados aqui. Clique em “Novo objeto” para carregar esses itens.",
        status: {
          waiting: "Este material está em processamento",
          fail: "Falha em processar o objeto de aprendizagem",
          waitingLabel:
            "Aguarde o carregamento do objeto, você visualizará ele aqui.",
          failLabel:
            "Houve uma falha ao carregar o objeto, tente fazer o upload novamente.",
        },
      },
    },
    avatar: {
      info: "Caso prefira, você pode selecionar um dos avatares abaixo como foto de perfil.",
    },
    password: {
      label:
        "Um e-mail informando como redefinir sua senha será enviado. Caso não encontre o e-mail, procure no lixo eletrônico ou caixa de spam. O e-mail pode demorar alguns segundos até chegar a sua caixa de entrada.",
    },
    skipModal: {
      title: "Próximo objeto?",
      subtitle:
        "Você não terminou de assistir, quer mesmo avançar? Se você avançar, pode ter dúvidas quando for responder o quiz.",
      next: "Avançar",
      finalize: "Cancelar",
    },
    attention: {
      title: "Está tudo bem, {user}?",
      subtitle:
        "Notamos que você não estava acompanhando o vídeo, por isso o pausamos. Deseja voltar para o vídeo?",
      info: "Caso queira, você pode desabilitar a detecção de atenção na tela de 'Conta'.",
      accept: "Retornar ao vídeo",
    },
    quiz: {
      title: "Quiz final",
      next: "Próxima",
      finalize: "Finalizar",
      saving: "Salvando",
      reply: "Responder",
      right: "Certo",
      wrong: "Errado",
      timeout: {
        title: "Tempo esgotado!",
        info: "Infelizmente acabou o tempo para responder o quiz. Vamos ver o resultado final e a correção de todas as questões?",
      },
      result: {
        title: "Resultado do quiz",
        currentPercentage: "Percentual de acertos",
        minPercentage: "Percentual mínimo para passar",
        duration: "Tempo para conclusão",
        empty: "Nenhuma questão foi respondida",
        done: "Concluído",
        proceed: "Prosseguir",
        more: "Mais materiais",
        moreMaterialsQuiz: "Ver a correção e depois os novos conteúdos",
        good: "Parabéns!",
        fail: "Não foi desta vez, mas não tem problema!",
        messageGood: "Você passou no quiz e concluiu o Objetivo",
        messageGoodMoreMaterials:
          "Ainda tem algumas aulas complementares nesse objetivo que você pode ver e adquirir mais conhecimentos, o que você deseja fazer?",
        messageFail:
          "você não acertou a quantidade necessária de questões, veja a correção abaixo. Após isso, você terá alguns conteúdos adicionais para que você possa revisar antes de tentar um novo quiz.",
      },
      teacher: {
        info: "Informações gerais",
        questions: "Questionário final",
        add: "Adicionar questão",
        edit: "Editar questão",
        delete: "Deletar questão",
        generateQuiz: "Gerar Quiz",
        buttons: {
          delete: "Deletar",
          cancel: "Cancelar",
        },
        deleteMessage: "Tem certeza que quer deletar essa questão?",
        list: "Lista de questões",
        duration: "Duração total",
        total: "Total de questões exibidas p/ o aluno",
        empty:
          "Ainda não há questões cadastradas. Clique em “Adicionar questão” para começar.",
        types: {
          multiple: "Multipla Escolha",
          trueFalse: "Verdadeiro ou Falso",
          dragAndDrop: "Drag end Drop (texto)",
          gap: "Preencher Lacunas",
        },
        typesInfo: {
          multiple:
            "Crie uma pergunta com várias opções e apenas uma resposta correta.",
          trueFalse:
            "Apresente itens que deverão ser classificados como verdadeiro ou falso.",
          dragAndDrop:
            "Crie textos nos quais o aluno deverá organizar corretamente os termos nas lacunas.",
          gap: "Elabore textos com lacunas a serem preenchidas.",
        },
      },
    },
    question: {
      info: "Informações gerais da questão",
      content: "Conteúdo relacionado",
      reference: "Referência de materiais",
      selectMaterials: "Selecionar objeto(s)",
      items: {
        create: "Criar item",
        delete: "Deletar",
        true: "Verdadeiro",
        false: "Falso",
      },
      prompt: {
        title: "Enunciado",
        empty: "Digite aqui o enunciado da questão",
        openQuestion: "Marcar como questão aberta",
        tooltip:
          "Ao marcar esta opção, o aluno pode responder essa pergunta aberta via chatbot.",
        items: {
          empty: "Digite aqui o item da questão",
          description: {
            title: "Explicação sobre o item ",
            empty: "Digite aqui a explicação sobre o item",
          },
        },
      },
    },
    stats: {
      course: {
        cards: {
          quiz: "Média geral das notas",
          attention: "Quantidade de alertas de detecção",
        },
        sidebar: {
          general: "Dados gerais",
          objectives: "Objetivos",
          quiz: "Quiz",
          students: "Alunos do curso",
          attentionLogs: "Logs de atenção",
          engage: "Engajamento",
          leanDash: "Engajamento de alunos",
        },
        charts: {
          titles: {
            inProgress: "Em andamento",
            enabled: "Ativaram",
            disabled: "Desativaram",
            inactive: "Inativos",
            conclude: "Concludentes",
          },
          engage: {
            engaged: "Engajados",
            disengaged: "Não engajados",
          },
          tooltips: {
            actives:
              "Alunos matriculados que assistiram pelo menos 1 objeto nos últimos 7 dias.",
            inactives:
              "Inativo há mais de 7 dias e sem visualizar nenhum objeto.",
            concluded: "Concluiu todos os quizzes de todos os objetivos.",
          },
        },
        students: {
          status: {
            inProgress: "Em andamento",
            active: "Ativo",
            inactive: "Inativo",
            done: "Concluído",
            approved: "Aprovado",
            failed: "Reprovado",
          },
        },
      },
      student: {
        sidebar: {
          general: "Dados gerais",
          objectives: "Objetivos",
          quiz: "Quiz",
          students: "Alunos do curso",
          map: "Mapa de conteúdos",
        },
      },
      objectives: {
        sidebar: {
          general: "Dados gerais",
          draftsFeedbacks: "Feedbacks escritos",
          questions: "Questões",
          objects: "Objetos",
          feedbacks: "Notas dos feedbacks",
        },
      },
    },
    crawler: {
      title: "Busca de vídeos",
      placeholder: "Pesquise palavra-chaves, termos...",
      indexWords: "Clique para ver as citações das palavras-chave no vídeo",
      words: {
        course: "Curso: ",
        chapter: "Capítulo: ",
        duration: "Duração: ",
      },
      empty: {
        title: "Nenhuma pesquisa realizada",
        description:
          "Utilize esta página para buscar vídeos por palavras-chave. Busque algo como “Swift”, “Matriz”, entre outros termos.",
      },
    },
    chat: {
      hello: "Olá, ",
      help: "como posso te ajudar? Aqui você pode:",
      start: `<div class='space-y-4'>
                <ul class="list-disc ml-6">
                  <li>
                    <p>Tirar dúvidas sobre conteúdos do curso;
                    </p>
                  </li>
                  <li>
                    <p>Dúvidas gerais sobre como funciona a plataforma.,</p>
                  </li>
                </ul>
                <p>Fale também por áudio, é só clicar no botão do microfone ou iniciar a frase com <strong>“Ajuda”, “Me ajude” ou “Preciso de ajuda”</strong>,</p>
              </div>`,
      reviewingContent: "Que tal revisarmos o conteúdo?",
      reviewLearned: "Vamos revisar o que você aprendeu! Responda a pergunta:",
      nextObjectWarning:
        "Você está no objeto inicial, então, não é possível voltar para o anterior.",
      testLearned: "Quero testar o que aprendi!",
    },
    voice: {
      low: "Lento",
      normal: "Normal",
      medium: "Médio",
      fast: "Rápido",
    },
    csvImport: {
      errors:
        "Não foi possível importar o arquivo abaixo. Verifique os erros nas seguintes linhas da lista, corrija as informações e importe um novo documento.",
      fileError: "Não foi possível importar o arquivo selecionado.",
      headers: {
        listError: "Erro ao importar lista",
        errorReport: "Relatório de erros",
        loading: "Importando arquivo...",
      },
    },
    organizations: {
      create: {
        buttons: {
          info: "Informações",
          course: "Cursos",
          user: "Usuários",
        },
      },
    },
    blacklist: {
      empty: {
        title: "Nenhuma palavra-chave",
        description:
          "Faça um upload de um vídeo ou aguarde o carregamento das palavras-chaves dos seus vídeos que já foram adicionados.",
      },
    },
    order: {
      header: "Lista de materiais de {name}",
    },
    classes: {
      status: {
        enabled: "Ativo",
        disabled: "Desativado",
      },
      create: {
        buttons: {
          info: "Informações da turma",
          select: "Selecionar usuários",
        },
        inputs: {
          name: "Nome da turma",
          initial: "Data de início",
          final: "Data final",
          select: "Selecionar cursos",
        },
      },
      event: {
        add: "Adicionar Aula",
        edit: "Editar aula",
        form: {
          buttons: {
            save: "Salvar",
            cancel: "Cancelar",
          },
          inputs: {
            course: "Curso",
            searchCourse: "Pesquisar curso",
            class: "Turma",
            searchClass: "Selecionar turma",
            title: "Título",
            titlePlaceholder: "Nome do evento/aula",
            date: "Data",
            datePlaceholder: "Selecionar data",
            startTime: "Inicia às",
            endTime: "Termina às",
            record: "Gravar aula",
            public: "Definir evento como público",
            confirm: "Sim",
            deny: "Não",
            externalLink: "Link externo",
            externalLinkPlaceholder:"Adicione um link externo para a aula",
          },
        },
      },
    },
    forum: {
      listForums: {
        title: "Gestão de Fórum",
      },
      listDenounces: {
        comments: {
          title: "Comentários denunciados",
          table: {
            columns: {
              author: "Autor do comentário",
              denounces: "Denúncias",
              status: "Status",
            },
          },
        },
        topics: {
          title: "Tópicos denunciados",
          table: {
            columns: {
              title: "Título do Tópico",
              author: "Autor do tópico",
              denounces: "Denúncias",
              status: "Status",
            },
          },
        },
        tableDenounces: {
          buttons: {
            toComments: "Denúncias de comentário",
            toTopics: "Denúncias de tópico",
          },
          paginatorText: "Mostrando {first}-{last} de {total} denúncias",
          columns: {
            denounceAuthor: "Autor da denúncia",
            dateOfDenounce: "Data da denúncia",
            description: "Motivo",
            status: "Status",
            actions: "Ações",
          },
        },
        dialog: {
          accept: {
            header: "Aceitar denúncia?",
            headerMultiple: "Aceitar {selectedDenounces} denúncia(s)?",
            topic:
              "Ao aceitar a(s) denúncia(s), o tópico será excluído e deixará de ficar disponível para os alunos. Após a confirmação, a ação não poderá ser desfeita.",
            comment:
              "Ao aceitar a(s) denúncia(s), o comentário será excluído e deixará de ficar disponível para os alunos. Após a confirmação, a ação não poderá ser desfeita.",
          },
          decline: {
            header: "Dispensar denúncia?",
            headerMultiple: "Dispensar {selectedDenounces} denúncia(s)?",
            topic:
              "Ao dispensar a(s) denúncia(s), o tópico continuará disponível no Fórum para os demais usuários da plataforma.",
            comment:
              "Ao dispensar a(s) denúncia(s), o comentário continuará disponível no Fórum para os demais usuários da plataforma.",
          },
        },
      },
      banner: {
        title: "Fórum",
      },
      comment: {
        authorDeleted: "Usuário",
      },
      topic: {
        details: {
          listComments: {
            title: "Comentários",
          },
        },
        denounce: {
          title: "Denunciar tópico",
          labels: {
            description:
              "Agradecemos por ajudar a manter nossa comunidade segura e acolhedora. Por favor, selecione o motivo da sua denúncia:",
          },
          buttons: {
            sendReport: "Enviar denúncia",
            cancel: "Cancelar",
          },
        },
        form: {
          title: "Criar novo tópico",
          editTitle: "Editar tópico",
          labels: {
            title: "Título do tópico",
            tag: "Capítulo associado",
            description: "Descrição",
            image: "Selecione uma imagem (opcional)",
            imageRequirements:
              "Formatos permitidos: PNG, JPG, JPEG e GIF. O tamanho máximo permitido é 10 MB.",
          },
          buttons: {
            imageSend: "Enviar",
            publish: "Publicar",
            cancel: "Cancelar",
          },
        },
        comment: {
          form: {
            title: "Editar comentário",
            label: {
              comment: "Comentário",
            },
            buttons: {
              cancel: "Cancelar",
              publish: " Publicar",
            },
          },
        },
      },
    },
    homeStudent: {
      filters: {
        name: "Pesquisar Cursos",
        classroom: {
          title: "Turma ",
          placeholder: "Selecione a turma",
        },
        status: {
          title: "Status de conclusão",
          placeholder: "Selecione o status",
        },
      },
    },
    calendar: {
      title: "Calendário de aulas",
      visualize: {
        label: "Visualizar",
        buttons: {
          add: "Adicionar aula",
        },
        autocomplete: {
          course: {
            placeholder: "Todos os cursos",
          },
          class: {
            placeholder: "Todas as turmas",
          },
        },
        select: {
          placeholder: "Todas as turmas",
        },
      },
    },
    theme: {
      admin: {
        title: "Temas",
        dialog: {
          title: "Tema de {value}",
        },
        empty: {
          description:
            "Você ainda não adicionou nenhuma turma clique em “Adicionar turma”.",
        },
      },
      org: {
        title: "Meu Tema",
        subdomain: "Subdomínio",
        logo: "Logo da Organização",
        partners: "Parceiros",
        primary: "Cor Primária",
        secondary: "Cor Secundária",
        action: "Alterar tema",
        form: {
          subdomain: "Subdomínio*",
          logo: "Logo da Organização* (.svg)",
          partners: "Logo dos Parceiros (.svg)",
          colors: "Cores",
          imagePicker: "Selecionar arquivo de imagem",
        },
      },
    },
    auth: {
      login: {
        title: "Efetue o Login",
        email: "Email",
        password: "Senha",
        keep: "Mantenha-me conectado",
        forgot: "Esqueci a senha",
        register: "Não tem uma conta?",
        link: "Cadastre-se",
      },
    },
    lean:{
      ranking:{
        attributes:{
          title: "{pt}",
          subtitle: "{pt}",
        }
      },
      statsAttributes: {
        done: "Objetivos concluídos",
        totalConcludedObjects: "Objetos concluídos",
        nps: "NPS",
        meanQuiz: "Média do Quiz",
        meanRates: "Taxas Médias",
        quantityLikedMaterials: "Materiais Curtidos",
        quantitySkippedMaterials: "Materiais Pulados",
        quantityLostAttention: "Perda de Atenção",
        attention_enabled: "Atenção Habilitada",
        outOfPattern: "Fora do padrão",
        averageTimeDelta: "Delta de Tempo",
        failedQuiz: "Quiz Reprovado",
        slope: "Inclinação",
        total_quantity_of_materials_in_the_course: "Total de matérias do curso",
        total_quantity_of_duration_in_the_course: "Duração total do curso",
      },
    }
  },
};
